import { Droplet, Sprout, Tractor, Heart, Recycle, Sun, Users, ShieldCheck, TrendingUp, Truck, CheckCircle, Leaf, Factory, GraduationCap, Briefcase } from 'lucide-react';
import { NavItem, SlideData, StatItem, TeamMember, Director } from './types';

export const NAV_ITEMS: NavItem[] = [
  { label: 'Home', id: 'home', type: 'link', path: '/' },
  { label: 'About', id: 'about', type: 'link', path: '/about' },
  { label: 'Products', id: 'products', type: 'link', path: '/products' },
  { label: 'Careers', id: 'careers', type: 'link', path: '/careers' },
  { label: 'Contact', id: 'contact', type: 'link', path: '/contact' },
];

export const INQUIRY_CATEGORIES = [
  'Wholesale',
  'Export',
  'Pricing',
  'Technical',
  'General'
];

export const HERO_SLIDES: SlideData[] = [
  // Round 1
  {
    id: 1,
    image: 'https://lh3.googleusercontent.com/d/1NW796vGzF7aQWL3Ev9x40V7vJ0CHoFof',
    title: 'Premium Avocado Oil Company',
    subtitle: 'Pure, Cold Press Crude Avocado Oil from Nyeri, Kenya',
    sectionId: 'products'
  },
  // Round 2
  {
    id: 4,
    image: 'https://lh3.googleusercontent.com/d/1E_Sm1ZE3cJ9VakTGmhLrk4Q80JDPN0I7',
    title: 'Nyeri Avocado Oil Experts',
    subtitle: 'Sustainable Agribusiness Focused on Quality and Health',
    sectionId: 'about'
  },
  // Round 3
  {
    id: 7,
    image: 'https://lh3.googleusercontent.com/d/1CB3YPYpsz0OyrS0IwO6waA7a4Gs_ClK_',
    title: 'Best Avocado Oil in Kenya',
    subtitle: 'Farm-to-Bottle Excellence with Zero Waste Sustainability',
    sectionId: 'products'
  },
  // Round 4
  {
    id: 10,
    image: 'https://lh3.googleusercontent.com/d/12nUeS2nlQ5PHfZL0ahYd2LTZE4f0jVMf',
    title: 'VILLA AVOILS',
    subtitle: 'Taste the Difference',
    sectionId: 'products'
  },
  // Round 5
  {
    id: 13,
    image: 'https://lh3.googleusercontent.com/d/1iK1YZRgn8OUAiNzxmoS2fpWM7Y4mlKxG',
    title: 'VILLA AVOILS',
    subtitle: 'Heart Healthy Choice',
    sectionId: 'products'
  },
];

// Expanded Team Data Structure
export const TEAM_ROLES: TeamMember[] = [
    {
        role: "Quality & Food Safety Manager",
        description: "Guardian of our ISO 22000 standards. Ensures every drop of oil meets rigorous international safety and purity benchmarks through continuous lab testing.",
        icon: ShieldCheck,
        image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=2000&auto=format&fit=crop"
    },
    {
        role: "Operations Manager",
        description: "Orchestrates the seamless flow from farm harvest to factory processing. Focuses on efficiency, waste reduction, and maintaining our zero-waste production cycle.",
        icon: Factory,
        image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?q=80&w=2000&auto=format&fit=crop"
    },
    {
        role: "Sales Manager",
        description: "The bridge between Villa Avoils and the world. Committed to connecting our premium Kenyan products with global markets in Europe, Asia, and the Americas.",
        icon: TrendingUp,
        image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?q=80&w=2000&auto=format&fit=crop"
    },
    {
        role: "Head of Logistics",
        description: "Manages our cold-chain supply network. Ensures that our avocado oil reaches destinations maintaining optimal freshness and quality.",
        icon: Truck,
        image: "https://images.unsplash.com/photo-1581092921461-eab62e97a782?q=80&w=2000&auto=format&fit=crop"
    },
];

export const TEAM_GROUPS = {
    interns: {
        role: "Internship Program",
        description: "The future generation of agronomists and food scientists. Our interns gain hands-on experience in sustainable agriculture and industrial processing.",
        image: "https://images.unsplash.com/photo-1523240795612-9a054b0db644?q=80&w=2000&auto=format&fit=crop"
    },
    farmers: {
        role: "Our Partner Farmers",
        description: "The backbone of Villa Avoils. Over 500 small-scale farmers in Nyeri who adhere to organic practices to provide the highest quality Hass avocados.",
        image: "https://images.unsplash.com/photo-1627920769843-16709841c107?q=80&w=2000&auto=format&fit=crop"
    }
}

export const DIRECTORS: Director[] = [
    {
        name: "Hon. Mutahi Kahiga",
        role: "Patron",
        image: "https://lh3.googleusercontent.com/d/1T8uRGDnS86vO_yTS2qKBSwLzDHK0uNq6",
        bio: "Serving as the Governor of Nyeri County, Hon. Mutahi Kahiga provides high-level strategic guidance, ensuring Villa Avoils aligns with regional development goals and empowers the local agricultural community."
    },
    {
        name: "Mr. George Mugi",
        role: "Chief Executive Officer",
        image: "https://lh3.googleusercontent.com/d/1tLh_n-d1OEqN1gVDA_IPNidgCLH3iH7y",
        bio: "A visionary leader with deep roots in Nyeri's agricultural sector. Mr. Mugi drives the company's mission to bridge traditional farming with modern industrial processing, ensuring sustainable growth and global market reach."
    },
    {
        name: "Ms. Mercy Kiguta",
        role: "Director",
        image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?q=80&w=1000&auto=format&fit=crop",
        bio: "Bringing extensive expertise in business administration and community development, Ms. Kiguta plays a pivotal role in fostering partnerships and overseeing the strategic expansion of Villa Avoils."
    }
];
